import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import NotFoundRoutes from './NotFoundRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes({ isAllowed }) {
    return useRoutes([MainRoutes(isAllowed), AuthenticationRoutes, NotFoundRoutes]);
}
